import { Ng2StateDeclaration } from '@uirouter/angular';
import { RoleViewComponent } from '@fi-app/role/role-view/role-view.component';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiRoleStateResolveRole } from '@fi-app/role/states/resolve/role';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiRoleViewState: Ng2StateDeclaration = {
    name: FiStateNames.Role.View,
    url: '/:Id',
    views: {
        '@': {
            component: RoleViewComponent,
        },
    },
    resolve: {
        role: FiRoleStateResolveRole,
        pageTitle: [PageTitleService, 'role', FiRoleViewStateResolve_pageTitle],
    },
};

export function FiRoleViewStateResolve_pageTitle(ccmPageTitle: PageTitleService, role) {
    return ccmPageTitle.setTitleByItem(role);
}
